<div class="root">
  <div *ngIf="showLoader" class="root__loader">
    <mat-spinner></mat-spinner>
  </div>

  <app-no-results *ngIf="showNoResults" class="root__no-results"></app-no-results>
  <table
    [ngClass]="{ hidden: showLoader || showNoResults }"
    class="table"
    mat-table
    matSort
    [dataSource]="dataSource"
  >
    <ng-container *ngFor="let column of _columns" [matColumnDef]="column.key">
      <!--      HEADER-->
      <ng-container *ngIf="column.sortable; else noSort">
        <th [style.flex]="column.flex" [mat-sort-header]="column.key" *matHeaderCellDef>
          <app-table-header [column]="column" />
        </th>
      </ng-container>
      <ng-template #noSort>
        <th [style.flex]="column.flex" *matHeaderCellDef>
          <app-table-header [column]="column" />
        </th>
      </ng-template>

      <!--      ROW-->
      <ng-container *matCellDef="let element">
        <td
          app-table-cell
          mat-cell
          [element]="element"
          [column]="column"
          [ngClass]="{ ellipsis: column.ellipsis, 'table__cell--highlight': column.highlighted }"
          [matTooltip]="column.ellipsis ? element[column.key] : null"
          matTooltipPosition="above"
          [style.flex]="column.flex"
        ></td>
      </ng-container>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="_displayedColumns"></tr>
    <tr
      class="table__row"
      [ngClass]="[rowClick ? 'table__row--clickable' : '', (rowClassFn && rowClassFn(row)) || '']"
      mat-row
      *matRowDef="let row; columns: _displayedColumns"
      (click)="handleRowClick(row)"
    ></tr>
  </table>

  <mat-paginator
    [ngClass]="{ hidden: hidePagination || showLoader || showNoResults }"
    class="pagination"
    [pageSizeOptions]="[10, 20, 30, 50, 100]"
    [showFirstLastButtons]="true"
  >
  </mat-paginator>
</div>
